<template>
    <div class="buy-now-confirmation">
        <transition name="fade">
            <div class="top-img-wrapper">
                <img v-show="bagImgLoaded" :src="require('home/buy-now/crema-cash-5.png')" class="top-img" alt="Crema Cash" v-on:load="bagImgLoaded = true">
            </div>
        </transition>

        <div class="confirmation-content-wrapper">
            <div v-if="subscribe && hasReferral">
                <h3 class="margin-top-sm">You'll still receive $5 off on your first 4 orders and then get $20 in site credit after your 8th order, for a total of $40 off.</h3>
                <br>
                <p>Have a look around and choose from any of the 100's of seasonal coffees we currently offer. You'll see in your banner have $5 in site credit that'll go towards your first purchase and then another $5 will be added after that, continuing for 8 orders. Also, the sweetheart of a human who referred you will also be getting $5 in site credit for each of your orders, to thank them for telling the world about us.</p>
            </div>
            <div v-else-if="subscribe">
                <h3 class="margin-top-sm">You'll recieve $10 in site credit after creating your account.</h3>
                <br>
                <p>Since we're not entirely sure which coffee you're going to choose to fall in love with first, we can't give you half off but the average small bag price is around $20 so you'll be close to half off (or maybe more).</p>
            </div>
            <div v-else> <!-- When subscribe is false -->
                <h3 class="margin-top-sm">You'll recieve $5 in site credit after creating your account.</h3>
                <br>
            </div>
        </div>

        <button @click="selectAddress(false)" class="btn-green-lg confirm-btn-lg margin-top-sm">
            <div v-if="processing" class="spinner">
                &nbsp
            </div>
            <span v-else>
                Save My Profile
            </span>
        </button>

        <div class="home-form padded margin-top-md">
            <fieldset>
                <input type="checkbox" id="newsletter" v-model="subscribeNewsLetter">
                <label for="newsletter" class="checkbox-label font-sm">Join our newsletter for a chance to win free coffee every week!</label>
            </fieldset>
        </div>
    </div>
</template>

<script>
    import CommonMixin from "../../../mixins/common-mixin"

    export default {
        mixins: [
            CommonMixin
        ],
        props: {
            username: String,
            address: Object,
            creditCardLastDigits: String,
            subscribe: Boolean,
            sizeCategory: String
        },
        data: function() {
            return  {
                processing: false,
                isOriginalAddressSelected: undefined,
                bagImgLoaded: false,
                subscribeNewsLetter: true,
                hasReferral: false
            }
        },
        mounted() {
            this.hasReferral = this.getReferralCodeCookie();
        },
        methods: {
            processOrder() {

            },
            getReferralCodeCookie() {
              const value = `; ${document.cookie}`;
              const parts = value.split(`; referral_code=`);
              if (parts.length === 2) return true;
              return false;
            },
            selectAddress() {
                if (this.processing) {
                    return;
                }
                this.processing = true;
                this.$emit('confirmed');
            },
            getEta() {
                const minDeliveryDays = 6;
                const maxDeliveryDays = 8;
                let range_min = new Date();
                let range_max = new Date();
                range_min.setDate(range_min.getDate() + minDeliveryDays);
                range_max.setDate(range_max.getDate() + maxDeliveryDays);
                return `${this.formatDateWithoutYear(range_min)} - ${this.formatDateWithoutYear(range_max)}`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .buy-now-confirmation {
        text-align: center;
        padding-top: 1rem;
        padding-bottom: 2rem;

        h3 {
            font-size: 22px;
            line-height: 2rem;
        }
        p {
            margin: 0;
            line-height: normal;
        }
    }
    .top-img-wrapper {
        min-height: 200px;
        margin-top: -46px;
        position: relative;
        top: 46px;
        text-align: left;
        .top-img {
            width: 80%;
            height: 80%;
        }
    }
    .user-address-wrapper {
        p {
            margin: 0;
        }
    }
    .confirmation-content-wrapper {
        padding-left: 2rem;
        padding-right: 2rem;
        margin-bottom: 2rem;
    }
    .total-price {
        color: $green-primary;
        font-size: 22px;
        margin-top: 1.5rem!important;
    }
    .confirm-btn-lg {
        width: 320px;
        font-size: 16px;
        padding: 0;
        text-align: center;
    }
    .spinner {
        font-size: 3px!important;
    }
    @media only screen and (max-width: $max-mobile-width) {
        .confirm-btn-lg {
            width: 280px;
            font-size: 14px;
        }
    }
</style>
